import React from "react"
import { IS_USING_CHRISTMAS_THEME } from "~Shared/config/consts"
import { SnowEffect } from "../snowEffect"

const FullScreen = ({ children, ...rest }: { children: React.ReactNode; [key: string]: any }) => (
    <main className={"min-w-screen min-h-screen overflow-hidden"}>
        {IS_USING_CHRISTMAS_THEME && (
            <>
                <div id="snow" className="absolute w-full h-full overflow-hidden" style={{ zIndex: 1 }} />
                <SnowEffect />
            </>
        )}

        {children}
    </main>
)

export default FullScreen
